// The event runs in Nashville, so all schedule times are shown in Nashville
// time, whatever the viewer's own time zone.
export const EVENT_TIME_ZONE = "America/Chicago";
export const EVENT_TIME_ZONE_LABEL = "CDT";

// Session times in the CMS were entered as Nashville clock times from a Studio
// running on UK time, so they are stored as Europe/London times. Reading them
// back in that zone gives the intended Nashville time. Once the CMS data is
// corrected, change this to EVENT_TIME_ZONE.
export const SCHEDULE_SOURCE_TIME_ZONE = "Europe/London";

function formatSessionTime(time, options) {
  return new Date(time).toLocaleString("en-US", {
    timeZone: SCHEDULE_SOURCE_TIME_ZONE,
    ...options
  });
}

function datePartsIn(time, timeZone, options) {
  const parts = {};
  new Intl.DateTimeFormat("en-US", { timeZone, ...options })
    .formatToParts(new Date(time))
    .forEach(part => {
      parts[part.type] = part.value;
    });
  return parts;
}

function toDateKey(time, timeZone) {
  const { year, month, day } = datePartsIn(time, timeZone, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  return `${year}-${month}-${day}`;
}

export function toFriendlyTime(timeUTZ) {
  return formatSessionTime(timeUTZ, { hour: "2-digit", minute: "2-digit" });
}

export function toFriendlyTimeWithAMPM(timeUTZ) {
  return formatSessionTime(timeUTZ, {
    hour: "numeric",
    minute: "numeric",
    hour12: true
  });
}

export function toFriendlyTimeAMPMObj(timeUTZ) {
  const { hour, minute, dayPeriod } = datePartsIn(
    timeUTZ,
    SCHEDULE_SOURCE_TIME_ZONE,
    { hour: "numeric", minute: "2-digit", hour12: true }
  );
  return { hours: hour, minute: minute, ampm: dayPeriod.toLowerCase() };
}

// e.g. "Oct 2"
export function toFriendlyDate(timeUTZ) {
  return formatSessionTime(timeUTZ, { month: "short", day: "numeric" });
}

// The event day a session falls on, as YYYY-MM-DD.
export function toEventDateKey(timeUTZ) {
  return toDateKey(timeUTZ, SCHEDULE_SOURCE_TIME_ZONE);
}

// Today's date in Nashville, as YYYY-MM-DD.
export function currentEventDateKey() {
  return toDateKey(new Date(), EVENT_TIME_ZONE);
}

function TimezoneDetect() {
  var dtDate = new Date("1/1/" + new Date().getUTCFullYear());
  var intOffset = 10000; //set initial offset high so it is adjusted on the first attempt
  var intMonth;
  var intHoursUtc;
  var intHours;
  var intDaysMultiplyBy;

  // Go through each month to find the lowest offset to account for DST
  for (intMonth = 0; intMonth < 12; intMonth++) {
    //go to the next month
    dtDate.setUTCMonth(dtDate.getUTCMonth() + 1);

    // To ignore daylight saving time look for the lowest offset.
    // Since, during DST, the clock moves forward, it'll be a bigger number.
    if (intOffset > dtDate.getTimezoneOffset() * -1) {
      intOffset = dtDate.getTimezoneOffset() * -1;
    }
  }

  return intOffset;
}
